import { Box } from '@mui/material'
import { useSelector } from 'react-redux'
import { customerAdminSelectUsers } from '../../../../redux/features/users/customerAdmin/customerAdminSlice'
import { retrieveCustomerAdminUsers, filterCustomerAdminUsers } from '../../../../redux/features/users/customerAdmin/customerAdminThunk'
import SortByList from '../../../../components/PageHelpers/Sort'
import SummariesBtn from '../../../../components/PageHelpers/SummariesBtn'
import UseTranslation from '../../../../hooks/UseTranslation'
import DropDownBatchButton from './DropDownBatchButton'
import TitleWithCountV2 from '../../../../components/PageHelpers/TitleWithCountV2'
import UsersList from '../../../../images/UsersList.svg'
import ActiveFilters from '../../../../components/PageHelpers/ActiveFilters'
import FilterBy from '../../../../components/PageHelpers/FilterBy'

const Desktop = () => {
  const customerAdminUsers = useSelector(customerAdminSelectUsers)
  const { t } = UseTranslation()

  return (
      <Box sx={styles.largeStyle}>
          <Box Box sx={styles.optionsBox}>
        <SummariesBtn
          actionToDispatch={retrieveCustomerAdminUsers}
          store={customerAdminUsers}
          sendQueryAsObject />
        <Box sx={styles.sortAddBox}>
          <SortByList
            actionToDispatch={retrieveCustomerAdminUsers}
            store={customerAdminUsers}
            sendQueryAsObject
            actionProps={{ pageNumber: 0 }}
          />
          <DropDownBatchButton />
        </Box>
      </Box>
      <Box sx={styles.filterBox}>
         <TitleWithCountV2
          icon={<img src={UsersList} alt="UsersList" />}
          iconSize='xl'
            store={customerAdminUsers}
            title={t?.Users}
            customCount={t?.Users}
            withCount
            customStyle={styles.titleHeader}
          />

        <FilterBy
        store={customerAdminUsers}
          actionToDispatch={filterCustomerAdminUsers}
        customStyle={styles.filterBy}
      />
      </Box>

      <ActiveFilters
          store={customerAdminUsers}
          actionToDispatch={filterCustomerAdminUsers}
          customStyle={styles.activeFilter}
        />
        </Box>

  )
}

const styles = {

  largeStyle: {
    width: '100%',
    display: { xs: 'none', sm: 'block' },
  },
  optionsBox: {
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    flexWrap: { xs: 'wrap', md: 'nowrap' },
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '15px',
    width: '100%',
  },
  sortAddBox: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    justifyContent: { xs: 'space-between', sm: 'flex-end' },
  },
  filterBox: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    alignItems: 'center',
    width: '100%',
  },
  titleHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginTop: '10px',
    marginBottom: '10px !important',
    gap: { xs: '5px', sm: '10px' },
    '& img': {
      paddingRight: '5px',
    },
    '& span': {
      fontFamily: 'Avenir 85 light',
      fontWeight: 400,
      fontSize: { xs: '16px', sm: '24px' },
      lineHeight: { xs: '20.15px', sm: '37.08px' },
    },
    '& p': {
      margin: '0',
    },
  },
  body: {
    width: '100%',
  },
  listContainer: {
    height: 'auto',
    padding: '0 23px 30px 30px',
    borderRadius: '12px',
    boxShadow: '0 1px 3px 0 #cfd8dc , 0 0 0 1px #f1f1f1',
    backgroundColor: '#ffffff',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    margin: 0,
    width: '100%',
    marginBottom: '1%',
  },
  userListContainer: {
    width: '100%',
  },
  option: {
    color: '#000000',
    textTransform: 'capitalize',
    minWidth: { xs: 'max-content', sm: '130px' },
    fontSize: { xs: '10px', sm: '16px' },
    margin: { xs: '3px 0', sm: '5px 0' },
    '& .MuiSvgIcon-root': {
      marginRight: { xs: '5px', sm: '7px' },
      width: { xs: '13px', sm: 'unset' },
      height: { xs: '13px', sm: 'unset' },
    },
    '& .MuiTypography-root': {
      fontSize: { xs: '11px', sm: '16px' },
    },
  },
  customCheckStyle: {
    width: '100%',
    padding: '0 5px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },

  sideButton: {
    width: '100%',
    textAlign: 'center',
    textTransform: 'capitalize',
    cursor: 'pointer',
    padding: '10px',
    margin: '1px -15px',
    marginLeft: '-15px',
    paddingTop: '8px',
    '&:hover': {
      backgroundColor: '#f7f9fb',
    },
  },
  filterBy: {
    marginRight: '0px',
  },
}

export default Desktop
